import React, { useState, useEffect } from 'react';
import { Alert, Spinner } from 'reactstrap';

import Content from 'src/layout/content/Content';
import Head from 'src/layout/head/Head';
import { Button } from 'src/components/Component';
import { Auth } from 'aws-amplify';
import Axios from 'axios';
import API_ROUTES from 'src/config/api';
import cssValidator from 'w3c-css-validator';
import { useSelector } from 'react-redux';
import CodeEditor from '@uiw/react-textarea-code-editor';

import { CheckCircleIcon, BellAlertIcon } from "@heroicons/react/24/outline";

const Styling = ({ ...props }) => {
  const { organisation } = useSelector((state) => state);

  const [cssInput, setCssInput] = useState('')
  const [validationMessage, setValidationMessage] = useState(null);
  const [changing, setChanging] = useState(false);

  useEffect(() => {
    setCssInput(organisation?.defaults?.PAYMENT_CSS);
  }, [organisation]);

  const validateAndApplyCss = async () => {
    setChanging(true);

    const result = await cssValidator.validateText(cssInput);

    if (result.valid === false) {
      setValidationMessage({ type: 'error', message: 'Invalid CSS. Please check your input.' });

      return null;
    }

    const user = await Auth.currentAuthenticatedUser();

    await Axios(
      API_ROUTES.user['organisation:default:update'](organisation.organisation),
      {
        method: 'post',
        data: {
          name: 'PAYMENT_CSS',
          value: cssInput,
        },
        headers: { Authorization: `Bearer ${user.signInUserSession.idToken.jwtToken}` },
      }
    );

    setChanging(false)

    setValidationMessage({ type: 'success', message: 'CSS is valid and has been applied.' });
  }

  return (
    <React.Fragment>
      <Head title="Styling" />
      <Content>
        {validationMessage && (
          <Alert className={validationMessage.type === 'success' ? 'bg-green-100 text-green-900 font-bold' : 'bg-red-100 text-red-900 border-red-500 font-bold'}>
            {validationMessage.type === 'success' ? <CheckCircleIcon className="h-6 w-6 float-left mr-2" /> : <BellAlertIcon className="h-6 w-6 float-left mr-2" />}
            {validationMessage.message}
          </Alert>
        )}
        <div className="border w-full">
          <div className="bg-gray-100 px-4 py-2 w-100">
            <h2 class="text-xl text-purple-900">Custom CSS | <strong>Payment Form</strong></h2>
          </div>
          <div className="px-4 py-4 w-100 overflow-hidden">
            <form onSubmit={(e) => { e.preventDefault(); validateAndApplyCss(); }} className="space-y-4">
              <div>
                <CodeEditor
                      language="css"
                  id="css-input"
                  value={cssInput}
                  onChange={(e) => setCssInput(e.target.value)}
                  placeholder="Enter your CSS here..."
                  className="min-h-[400px] border border-slate-300 w-100"
                  padding={15}
                  data-color-mode="light"
                  style={{
                    fontSize: 14,
                    fontFamily: 'ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace',
                  }}
                />
              </div>
              <Button disabled={changing} className="btn bg-violet-800 hover:bg-violet-600 text-white float-right" type="submit">
                {changing ? <Spinner size="sm" color="light"> </Spinner> : "Validate and Apply"}
              </Button>
            </form>
          </div>

        </div>
      </Content>
    </React.Fragment>

  );
};

export default Styling;
